import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwFileUploader";
import "./klass.VuwThumbnail";
import "../klass.VuwTextField";

/**
 * VuwFileset for VuwFileField (extends VuwField)
 * @options
 * - @required {string} dataType
 * - {object} formConf: keys->[ACTION_URL]
 * - {object} caption: keys->[name, required, ltd, placeholder]
 * - {string} requiredText
 * - {function} getFileUrl(ext)
 */
vuwer.appendKlass("VuwFileset", {
	inpType: "set",
	dataType: false,
	inpClassList: ["inp", "inp-file"],
	requiredText: "",
	getFileUrl: function getFileUrl(ext) {},
	
	defaultChildProp: {
		fUploader: {
			vuwType: "fileUploader",
			showLoading: function showLoading() {
				this.container.$areaUpl.addClass("is-uploading");
				return $.Deferred(function(df) {
					setTimeout(df.resolve, 200);
					return df.promise();
				});
			},
			hideLoading: function hideLoading() {
				this.container.$areaUpl.removeClass("is-uploading");
			},
			
			_sendRequest: function _sendRequest() {
				var vuwForm = this.container.getForm();
				return vuwForm._sendRequest.apply(this, arguments);
			},
			_aSubmitLegacy: function _aSubmitLegacy() {
				var vuwForm = this.container.getForm();
				return vuwForm._aSubmitLegacy.apply(this, arguments);
			},
			
			// callbacks
			begin: function begin($form, opt, vuwFileUploader) {
				if( u_.isFunction(this.fileField.uploadCallbacks.begin) ) {
					this.fileField.uploadCallbacks.begin.apply(
						this.container,
						u_.getAsArray(arguments).concat(this)
					);
				}
			},
			onError: function onError(error) {
				var vuwFileset = this.container;
				
				$.when( u_.isFunction(this.fileField.uploadCallbacks.onError) &&
					this.fileField.uploadCallbacks.onError.apply( vuwFileset, u_.getAsArray(arguments) )
				).then( vuwFileset.clearVal.bind(vuwFileset) );
			},
			onSelect: function onSelect(selectedFilePath, selectedFileName) {
				var vuwFileset = this.container;
				
				vuwFileset.setState("isSelected", true);
				this.getOther("thumbnail").setState("fname", selectedFileName);
				
				// captionの処理
				!!vuwFileset.caption && (function(caption) {
					var state  = {
						disabled: false
					};
					!!caption.required && (state.required = true);
					!!caption.placeholder && (state.placeholder = caption.placeholder);
					
					if( (/\{/g).exec(state.placeholder) ) {
						state.placeholder = u_.replacePathinfo(state.placeholder, selectedFilePath);
					}
					
					this.getOther("caption").setState(state);
				}).call(this, vuwFileset.caption);
				
				if( u_.isFunction(this.fileField.uploadCallbacks.onSelect) ) {
					this.fileField.uploadCallbacks.onSelect.apply( vuwFileset, u_.getAsArray(arguments) );
				}
			},
			onDisSelect: function onDisSelect(paramKey) {
				var vuwFileset = this.container;
				
				vuwFileset.setVal("");
				
				// captionの処理
				!!vuwFileset.caption && (function(caption) {
					var state  = {
						disabled: true
					};
					!!caption.required && (state.required = false);
					this.getOther("caption").setState(state);
				}).call(this, vuwFileset.caption);
				
				if( u_.isFunction(this.fileField.uploadCallbacks.onDisSelect) ) {
					this.fileField.uploadCallbacks.onDisSelect.apply( vuwFileset, u_.getAsArray(arguments) );
				}
			},
			onFileRead: function onFileRead(ulFile, content) {
				var
					vuwFileset = this.container,
					thumbnail = this.getOther("thumbnail");
				
				if( u_.isFunction(this.fileField.uploadCallbacks.onFileRead) ) {
					this.fileField.uploadCallbacks.onFileRead.apply( vuwFileset, u_.getAsArray(arguments) );
				}
				
				thumbnail.setState("src", content);
			},
			onUpload: function onUpload(res) {
				var
					vuwFileset = this.container,
					vuwForm = vuwFileset.getForm(),
					keys = vuwFileset.paramKey.split("_");	// ex) "imgs_01" -> ["imgs", "01"]
				
				if(	u_.isObject(res.keep) &&
						u_.isObject(res.keep[ keys[0] ]) &&
						res.keep[ keys[0] ][ keys[1] ]
				) {
					vuwFileset.$inp.val(res.keep[ keys[0] ][ keys[1] ]);
					
					vuwFileset.get("thumbnail").setState( "src", [
						vuwForm.config.fileDir || "",
						res.dir,
						res.keep[ keys[0] ][ keys[1] ]
					].join("/") );
					
				} else {
					csl.warn("onUpload", ["keep"].concat(keys).join(".") + " is not found.", res.keep);
				}
				
				if( u_.isFunction(this.fileField.uploadCallbacks.onUpload) ) {
					this.fileField.uploadCallbacks.onUpload.apply( vuwFileset, u_.getAsArray(arguments) );
				}
				
				// for refresh error prompt
				vuwFileset.$self.trigger("change", [true]);
			}
		},
		thumbnail: {
			vuwType: "fileThumbnail"
		},
		caption: {
			vuwType: "textField",
			onChangeState: function onChangeState(state) {
				var val;
				if(state.hasOwnProperty("disabled") && this.$self.hasClass("is-disable") !== state.disabled) {
					this.$self.toggleClass("is-disable", !!state.disabled);
					val = this.getVal();
					if( state.placeholder && (!val || val === state.placeholder) ) {
						this.setVal(state.disabled ? "" : state.placeholder);
					}
				}
			}
		}
	},
	
	_initialize: function _initialize(opt) {
		var vuwForm;
		if( Klass("VuwFileset").parent._initialize.call(this, opt) ) {
			vuwForm = this.getForm();
			if(!vuwForm) {
				csl.warn(this.klass + " must be VuwForm's child.");
				return false;
			}
			
			if(!this.dataType) {
				csl.warn.red(this.getAddress() + "._initialize() ... no dataType.");
				return false;
			}
			
			// [入力部品のクラス]
			this.inpClassList.push("inp-" + this.dataType);
			
			u_.isObject(this.formConf) || (this.formConf = {});
			
			this
			// [add file uploader]
			.add("fUploader", Object.assign(this.formConf, this.defaultChildProp.fUploader, {
				dataType: this.dataType,
				inpFileName: this.paramKey.replace("_", "[") + "]",
				inpFileId: ["inp", this.idStr, "fu"].join("_"),
				fileField: this.container,
				ajaxErrorCallback: vuwForm.ajaxErrorCallback.bind(vuwForm)
			}))
			
			// [add file thumbnail]
			.add("thumbnail", Object.assign({}, this.defaultChildProp.thumbnail, {
				dataType: this.dataType
			}));
			
			if( u_.isObject(this.caption) ) {
				// [add caption]
				this.add("caption", Object.assign({}, this.defaultChildProp.caption, {
					paramKey: this.paramKey + "_cap",
					//required: !!this.caption.required,	requiredは動的に変更
					ltd: this.caption.ltd || 0
				}));
			}
			
			this
			.onReady(function() {
				var vuwForm = this.getForm();
				!!vuwForm.config.requiredText && (this.requiredText = vuwForm.config.requiredText);
				return this.renderField();
			})
			.onChangeState(function(state) {
				if( state.isSelected !== this.$self.hasClass("is-selected") ) {
					this.$self.toggleClass("is-selected", !!state.isSelected);
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		// DOMツリーに登録される前のことも考慮して、$self.findで取得する
		this.$inp = $self.children( "#" + ["inp", this.idStr].join("_") );
		this.$areaUpl = $self.children(".area-upl");
		this.$btnSelFile = this.$areaUpl.find(".btn-sel");
		
		if(!this.$inp.length) {
			return false;
		}
		
		$self.on("click", ".btn-del", function(e) {
			var vuwLast, vuw = $.data(e.delegateTarget, "vuw");
			e.preventDefault();
			
			if(vuw.container) {
				vuw.container.remove(vuw.name);
				!!vuw.container.$self && vuw.container.$self.removeClass("is-limit");
				if( vuw.$self.hasClass("is-last") ) {
					vuwLast = vuw.container.getLastFileset();
					!!vuwLast && vuwLast.$self.addClass("is-last");
				}
			}
		});
		
		$.data(this.$inp.get(0), "vuwField", this);
		this.clearVal(true);
	},
	
	validate: function validate() {
		var err_cnt = 0;
		if( this.get("caption") ) {
			this.get("caption").validate() || err_cnt++;
		}
		return !err_cnt;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		var promiseList = [];
		
		if( u_.isObject(value) ) {
			!!this.$inp.length && this.$inp.val(value.ext || "");
			promiseList.push( this.setState("isSelected", true) );
			promiseList.push( this.get("thumbnail").setState("src", this.getFileUrl(value.ext)) );
			if( u_.isObject(this.caption) ) {
				promiseList.push(
					this.get("caption").setVal(value.name || "", antiTriggerChange).setState("disabled", false)
				);
			}
		} else {
			!!this.$inp.length && this.$inp.val("");
			promiseList.push( this.setState("isSelected", false) );
			promiseList.push( this.get("thumbnail").setState("fname", "") );
			if( u_.isObject(this.caption) ) {
				promiseList.push(
					this.get("caption").setVal("", antiTriggerChange).setState("disabled", true)
				);
			}
		}
		
		(!antiTriggerChange && this.$inp.length) && this.$inp.trigger("change", [true]);
		
		return $.when.apply($, promiseList);
	},
	
	getVal: function getVal() {
		var val = {
			ext: this.$inp.val()
		};
		if( u_.isObject(this.caption) ) {
			val.name = this.get("caption").getVal();
		}
		return val;
	},
	
	_getCopiedInp: function _getCopiedInp() {
		var $areaUpl, vuwCap, clones = [];
		
		!!this.$self && ( $areaUpl = this.$self.children(".area-upl").clone() );
		if($areaUpl && $areaUpl.length) {
			vuwCap = this.get("caption");
			$areaUpl.children(".file-controller").remove();
			
			$areaUpl.$a = $areaUpl.find(".file-thumb > a").clone();
			if($areaUpl.$a.length) {
				// PDFなど
				!!vuwCap && ( $areaUpl.cap = vuwCap.getVal() );
				if($areaUpl.cap) {
					$areaUpl.$a.children("span").text($areaUpl.cap);
				}
				clones.push( $areaUpl.$a.addClass("replaced-inp") );
			} else {
				// img, videoなど
				clones.push($areaUpl);
				!!vuwCap && clones.push( vuwCap.getCopiedElement().prepend(
					vuwCap.$self.children("label").eq(0).clone().attr("for", "")
				) );
			}
		}
		
		return clones;
	},
	
	_renderField: function _renderField() {
		var
			$elm = $("<div/>").addClass("vuw-fileset").attr("data-type", this.dataType),
			attr = {
				type: "hidden",
				name: this.paramKey.replace("_", "[") + "]",
				id: ["inp", this.idStr].join("_")
			},
			elms = [],
			vuwThumb, vuwCap, $lbl;
		
		if(this.name.indexOf("_") >= 0) {
			$elm.attr("data-index", this.name.split("_")[1]);
		}
		
		// サムネイルのDOM生成
		vuwThumb = this.get("thumbnail");
		vuwThumb.$self = $("<var/>");
		
		elms.push( $("<input/>").addClass( this.inpClassList.join(" ") ).attr(attr) );
		elms.push( $("<span/>").addClass("area-upl upl-" + this.dataType).append(
			$("<span/>").addClass("file-thumb").append( vuwThumb.$self ),
			$("<span/>").addClass("file-controller").append(
				$("<label/>").attr("for", attr.id + "_fu").addClass("btn-sel hover-target").append("<span/>"),
				$("<a/>").addClass("btn-del").append("<span/>")
			)
		) );
		
		$.fn.append.apply($elm, elms);
		
		vuwCap = this.get("caption");
		if(vuwCap) {
			// キャプションのDOM生成
			vuwCap.$self = $("<var/>").appendTo($elm);
			vuwCap.renderField();
			vuwCap.$inp.attr("name", vuwCap.$inp.attr("name").replace("_", "--name[").replace(/_cap$/, "]"));
			vuwCap.$self.attr( "data-name", vuwCap.$inp.attr("name") ).addClass("field-cap");
			if( this.caption.name && u_.isString(this.caption.name) ) {
				$lbl = $("<label/>").addClass("param-name").attr( "for", vuwCap.$inp.attr("id") ).append(
					$("<span/>").text(this.caption.name)
				).insertBefore(vuwCap.$inp);
				
				if(this.caption.required) {
					$("<span/>").addClass("required").text(this.requiredText || "").appendTo($lbl);
				}
				
				if(this.caption.ltd) {
					$("<span/>").addClass("limit").attr("data-limit", this.caption.ltd).appendTo($lbl);
				}
			}
		}
		
		return $elm;
	}
}, "VuwField");

